if (!customElements.get('lls-hot-spot')) {
  class LlsHotSpot extends HTMLElement {
    static SELECTORS = {
      dot: '.lls-hot-spot__dot',
      popup: '.lls-hot-spot__popup',
      close: '.lls-hot-spot__close',
    };

    static ATTRS = {
      open: 'data-open',
    };

    static EVENTS = {
      open: 'lls-hot-spot:open',
      close: 'lls-hot-spot:close',
    };

    static MOBILE_BREAKPOINT = 999;
    static SCROLL_LOCK_CLASS = 'lls-hot-spot-scroll-locked';

    connectedCallback () {
      this._dot = this.querySelector(LlsHotSpot.SELECTORS.dot);
      this._popup = this.querySelector(LlsHotSpot.SELECTORS.popup);
      this._closeBtn = this.querySelector(LlsHotSpot.SELECTORS.close);

      if (!this._dot || !this._popup) return;

      this._abort = new AbortController();
      const { signal } = this._abort;

      this._dot.addEventListener('click', (e) => this._onDotClick(e), { signal });
      this._closeBtn?.addEventListener('click', () => this.close(), { signal });
      this._popup.addEventListener('click', (e) => e.stopPropagation(), { signal });
      this.addEventListener('click', (e) => this._onHostClick(e), { signal });

      document.addEventListener('keydown', (e) => this._onKeydown(e), { signal });
      document.addEventListener('click', (e) => this._onDocumentClick(e), { signal });
      document.addEventListener(LlsHotSpot.EVENTS.open, (e) => this._onOtherOpen(e), { signal });
    }

    disconnectedCallback () {
      this._abort?.abort();
      this._unlockScroll();
    }

    open () {
      if (this.hasAttribute(LlsHotSpot.ATTRS.open)) return;
      this.setAttribute(LlsHotSpot.ATTRS.open, '');
      this._dot.setAttribute('aria-expanded', 'true');
      this._popup.setAttribute('aria-hidden', 'false');
      if (this._isMobile()) this._lockScroll();
      this.dispatchEvent(new CustomEvent(LlsHotSpot.EVENTS.open, { bubbles: true }));
    }

    close () {
      if (!this.hasAttribute(LlsHotSpot.ATTRS.open)) return;
      this.removeAttribute(LlsHotSpot.ATTRS.open);
      this._dot.setAttribute('aria-expanded', 'false');
      this._popup.setAttribute('aria-hidden', 'true');
      this._unlockScroll();
      this.dispatchEvent(new CustomEvent(LlsHotSpot.EVENTS.close, { bubbles: true }));
    }

    _onDotClick (event) {
      event.stopPropagation();
      this.hasAttribute(LlsHotSpot.ATTRS.open) ? this.close() : this.open();
    }

    _onHostClick (event) {
      if (event.target === this) this.close();
    }

    _onDocumentClick (event) {
      if (!this.hasAttribute(LlsHotSpot.ATTRS.open)) return;
      if (this.contains(event.target)) return;
      this.close();
    }

    _onKeydown (event) {
      if (event.key === 'Escape' && this.hasAttribute(LlsHotSpot.ATTRS.open)) this.close();
    }

    _onOtherOpen (event) {
      if (event.target !== this && this.hasAttribute(LlsHotSpot.ATTRS.open)) this.close();
    }

    _isMobile () {
      return window.matchMedia(`(max-width: ${LlsHotSpot.MOBILE_BREAKPOINT}px)`).matches;
    }

    _lockScroll () {
      document.documentElement.classList.add(LlsHotSpot.SCROLL_LOCK_CLASS);
    }

    _unlockScroll () {
      if (!document.querySelector(`lls-hot-spot[${LlsHotSpot.ATTRS.open}]`)) {
        document.documentElement.classList.remove(LlsHotSpot.SCROLL_LOCK_CLASS);
      }
    }
  }

  customElements.define('lls-hot-spot', LlsHotSpot);
}
